export const DOWNLOAD_TEMPLATE = 'DOWNLOAD_TEMPLATE';
export const DOWNLOAD_TEMPLATE_SUCCESS = 'DOWNLOAD_TEMPLATE_SUCCESS';
export const DOWNLOAD_TEMPLATE_FAILED = 'DOWNLOAD_TEMPLATE_FAILED';

export const UPLOAD = 'UPLOAD';
export const UPLOAD_SUCCESS = 'UPLOAD_SUCCESS';
export const UPLOAD_FAILED = 'UPLOAD_FAILED';
